import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Loader, EmptyState } from "@/components/ui-kit";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { usePartnerMeta, can, Pill } from "@/lib/partner";
import { Sel, CloseActionDialog } from "@/components/partner/PartnerDialogs";
import { ListTodo } from "lucide-react";
import { toast } from "sonner";

const TITLES = { "": ["Actions et activités", "Toutes les actions liées aux contacts et partenaires"], relances: ["Tâches et relances", "Appels, e-mails, messages, relances et tâches administratives"],
  reunions: ["Réunions et rendez-vous", "Rendez-vous, réunions et visites planifiés"] };
const ALL = "__all";

export default function PartnerActions({ kind = "" }) {
  const [meta] = usePartnerMeta();
  const [items, setItems] = useState(null);
  const [f, setF] = useState({});
  const [close, setClose] = useState(null);
  const load = () => {
    const p = { kind, ...Object.fromEntries(Object.entries(f).filter(([, v]) => v && v !== ALL)) };
    api.get("/partners/actions", { params: p }).then((r) => setItems(r.data)).catch((e) => { toast.error(apiErr(e)); setItems([]); });
  };
  useEffect(() => { load(); }, [kind, JSON.stringify(f)]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!meta || items === null) return <Loader />;
  const today = new Date().toISOString().slice(0, 10);
  const [title, sub] = TITLES[kind];
  return (
    <div data-testid={`partner-actions-${kind || "all"}`}>
      <PageHeader title={title} subtitle={sub} />
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="w-48"><Sel value={f.statut || ALL} onChange={(v) => setF({ ...f, statut: v })} options={[[ALL, "Tous statuts"], ...meta.action_statuses]} testid="action-filter-status" /></div>
        <div className="w-52"><Sel value={f.responsable_id || ALL} onChange={(v) => setF({ ...f, responsable_id: v })} options={[[ALL, "Tous responsables"], ...meta.users.map((u) => [u.id, u.name])]} testid="action-filter-owner" /></div>
        <label className="text-sm flex items-center gap-2"><input type="checkbox" checked={!!f.en_retard} onChange={(e) => setF({ ...f, en_retard: e.target.checked })} data-testid="action-filter-late" />En retard uniquement</label>
      </div>
      {items.length === 0 ? <EmptyState icon={ListTodo} title="Aucune action" subtitle="Planifiez des actions depuis un contact ou une fiche partenaire." /> : (
        <div className="rounded-xl border bg-white overflow-x-auto"><Table>
          <TableHeader><TableRow className="bg-slate-50"><TableHead>Date</TableHead><TableHead>Type</TableHead><TableHead>Titre</TableHead><TableHead>Lié à</TableHead><TableHead>Responsable</TableHead><TableHead>Priorité</TableHead><TableHead>Statut</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>{items.map((a) => {
            const late = ["À faire", "En cours", "Reportée"].includes(a.statut) && a.date_prevue < today;
            return (
              <TableRow key={a.id} data-testid={`action-row-${a.id}`}>
                <TableCell className={`text-sm whitespace-nowrap ${late ? "text-rose-600 font-semibold" : ""}`}>{a.date_prevue}{late && " · en retard"}</TableCell>
                <TableCell className="text-sm">{a.type}</TableCell><TableCell className="font-medium text-sm">{a.titre}</TableCell>
                <TableCell className="text-sm">{a.partner_id ? <Link className="text-brand-700 hover:underline" to={`/partenariat/fiche/${a.partner_id}`}>{a.cible}</Link> : a.cible}</TableCell>
                <TableCell className="text-sm">{a.responsable_name}</TableCell><TableCell className="text-xs">{a.priorite}</TableCell><TableCell><Pill s={a.statut} /></TableCell>
                <TableCell>{can(meta, "actions") && !["Réalisée", "Annulée"].includes(a.statut) && <Button size="sm" variant="outline" onClick={() => setClose(a)} data-testid={`action-update-${a.id}`}>Mettre à jour</Button>}</TableCell>
              </TableRow>);
          })}</TableBody></Table></div>
      )}
      <CloseActionDialog action={close} onClose={() => setClose(null)} meta={meta} onSaved={load} />
    </div>
  );
}
